import interpolate from 'lib/interpolate';
import { GET, POST } from '../store/lib/xhr';
import Kibana from '../utils/trackKibana';
import invariant from 'fbjs/lib/invariant.js';

const kibana = new Kibana('InteractiveApi');

export default class InteractiveApi {
  #pendingQuery = [];
  #callbacks;
  #token;
  #baseUrl;
  #getConfigUrl;
  #configVersion;

  constructor(configProvider, callbacks) {
    invariant(configProvider, 'configProvider is required');

    configProvider.subscribe((config) => {
      this.#token = config.token;
      this.#baseUrl = config.api_config.url;
      this.#getConfigUrl = interpolate.bind(
        this,
        config.api_config.video_config_url,
      );
      this.#configVersion = config.api_config.version;

      this.#pendingQuery.forEach((callback) => callback());
      this.#pendingQuery.length = 0;
    });
    this.#callbacks = callbacks;
    // this.#configPattern = video_config_url.replace(api_url, '');
  }

  get #Authorization() {
    return `Bearer ${this.#token}`;
  }

  query(path, method = GET, payload = undefined) {
    const url = this.#baseUrl + path;
    return method(
      url,
      [
        ['Authorization', this.#Authorization],
        ['Accept', 'application/json'],
        /*
          ['Cache-control', 'max-age=300' /!* 'no-cache' /!* TODO: which cache-control we should use? !/ *!/],
      */
      ],
      payload,
    ).catch((error) => {
      const { code } = JSON.parse(error.message);
      const handler = this.#callbacks[code];

      if (handler) {
        // TODO: make callback with retry function
      }
      this.#callbacks[code]?.();
      if (code === 401) {
        return new Promise((resolve) => {
          this.#pendingQuery.push(() =>
            resolve(this.query(path, method, payload)),
          );
        });
      } else {
        /* TODO: avoid twice reporting about one problem:
         *   - reporting from here
         *   - reporting from extensions */
        error.url = url;
        kibana.error(error);
      }
      throw error;
    });
  }

  post(path, payload) {
    return this.query(path, POST, payload);
  }

  init() {
    return this.query('/v1/init', POST);
  }

  getConfig(object) {
    const url = this.#getConfigUrl(object);
    return this.query(url).then((config) => {
      config._version = this.#configVersion;

        // TODO: remove after BE updates config for quiz
        config.quiz ??= {
          enabled: true,
        };
        // TODO: remove manual patching
        config['debug-layer'] ??= {
          enabled: true,
        };

      kibana.info('config fetched', {
        object,
        config,
      });

      // TODO: move here all other config "modifications" from fetchObjectConfig,
      //  except replacing video_id in templates
      return config;
    });
  }

  /*
      updateToken(newToken) {
        authorization = `Bearer ${newToken}`;
        pendingQuery.forEach((callback) => callback());
        pendingQuery.length = 0;
      },
  */
}
